import MultiSelectDropdown from "../dropdowns/multiSelectDropdown";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_PRELOAD_SIZE } from "../../utils/constants";
import useApiClient from "../../hooks/useApiClient";
import { useState } from "react";
import { useDebouncedFunction } from "../../hooks/useDebouncedQueryParams";
import { DEBOUNCE_DELAY } from "../../utils";
import { MultiSelectDropdownSmartWrapperProps } from "../dropdowns/types";
import { QUERY_OPTIONS_LOAD_ONCE } from "../../apiUtils";
import { titleCase } from "../../utils";


interface SealogEventValueDropdownProps {
    dropdownProps: MultiSelectDropdownSmartWrapperProps<string, string>;
    apiOptions: {
        eventFreeTexts?: string[],
        eventOptionNames?: string[],
        eventOptionValues?: string[],
        realAssetDeploymentPublicId?: string,
        hasDataAsset?: boolean,
    };
}

export const SealogEventValueDropdown = ({
    apiOptions,
    dropdownProps,
}: SealogEventValueDropdownProps) => {
    const api = useApiClient();
    const [debouncedSearchTerm, _setDebounceSearchTerm] = useState("");
    const setDebounceSearchTerm = useDebouncedFunction(
        _setDebounceSearchTerm,
        DEBOUNCE_DELAY
    );

    const mergedApiOptions = {
        size: DROPDOWN_PRELOAD_SIZE,
        query: debouncedSearchTerm || undefined,
        ...apiOptions
    }
    const { data: sealogEventValues, isLoading: sealogEventValuesAreLoading } = useQuery({
        queryKey: ["sealogEventValues", ...Object.entries(mergedApiOptions)],
        queryFn: () => api.sealog.listUniqueSealogEventValues(mergedApiOptions).then(r => r.items),
        ...QUERY_OPTIONS_LOAD_ONCE,
    });

    return (
        <MultiSelectDropdown<string, string>
            label={"Event Type"}
            options={sealogEventValues ?? []}
            selections={[]}
            isLoading={dropdownProps.isLoading || sealogEventValuesAreLoading}
            renderOption={(o) => titleCase(o)}
            onSearchTermChange={setDebounceSearchTerm}
            mapOptionToSelection={o => o}
            {...dropdownProps}
        />
    )
}